export default "__VITE_ASSET__gxd1dV_u__"